import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import "./app-shell.css";

const getNavItems = (role) => {
  const isMereferencio = window.location.hostname.includes("mereferencio");
  if (isMereferencio || role === "ARRENDATARIO") {
    return [
      { label: "Evaluar", path: "/consultar-puntaje" },
    ];
  }
  return [
    { label: "Contratos", path: "/contratos" },
    { label: "Reportar", path: "/reportar" },
    { label: "Evaluar", path: "/consultar-puntaje" },
    { label: "Administrar", path: "/inmuebles/administrar" },
    { label: "Parametrizacion", path: "/parametrizacion" },
  ];
};

export default function AppShell({
  eyebrow = "Sistema de Referencias",
  title,
  subtitle,
  children,
  heroActions = null,
  contentClassName = "",
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMereferencio = window.location.hostname.includes("mereferencio");

  // ============================
  // 🔥 LECTURA ESTABLE DE STORAGE
  // ============================
  const auth = useMemo(() => {
    return {
      role: localStorage.getItem("role"),
      roleLabel: localStorage.getItem("role_label"),
      userName:
        localStorage.getItem("full_name") ||
        localStorage.getItem("user"),
      token: localStorage.getItem("token"),
    };
  }, []);

  const roleLabel = auth.roleLabel || auth.role;
  const token = auth.token;
  const userName = auth.userName;

  // ============================
  // NAV ESTABLE
  // ============================
  const navItems = useMemo(() => {
    return getNavItems(auth.role);
  }, [auth.role]);

  const logout = () => {
    localStorage.clear();
    navigate(isMereferencio ? "/login-arrendatario" : "/login");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="app-ui">
      <div className="app-shell">

        {/* HEADER */}
        <header className="app-topbar">
          <button
            className="app-brand"
            type="button"
            onClick={() =>
              navigate(token ? (isMereferencio || auth.role === "ARRENDATARIO" ? "/consultar-puntaje" : "/referencias") : (isMereferencio ? "/login-arrendatario" : "/login"))
            }
          >
            <div className="app-brand-logo-wrapper">
              <img
                className="app-brand-logo"
                src="/images/logo_user.jpg"
                alt="Referenciate Logo"
              />
              <span className="logo-destello-beam"></span>
              <span className="logo-destello-sparkle"></span>
            </div>

            <span className="app-brand-copy">
              <strong>Sistema de Referencias</strong>
            </span>
          </button>

          <div className="app-topbar-tools">

            {token && userName && (
              <span className="app-user-label">
                {userName}
              </span>
            )}

            {token && roleLabel && (
              <span className="app-role-chip">
                {roleLabel}
              </span>
            )}

            {/* NAV */}
            {navItems.length > 0 && (
              <nav className="app-shortcuts">
                {navItems.map((item) => (
                  <button
                    key={item.path}
                    type="button"
                    onClick={() => navigate(item.path)}
                    className={`app-nav-link ${isActive(item.path) ? "active" : ""
                      }`}
                  >
                    {item.label}
                  </button>
                ))}
              </nav>
            )}

            {/* ACTIONS */}
            <div className="app-toolbar-actions">

              {token && !isMereferencio && auth.role !== "ARRENDATARIO" && (
                <button
                  type="button"
                  className="app-button app-button--secondary"
                  onClick={() => navigate("/referencias")}
                >
                  Menu
                </button>
              )}

              <button
                type="button"
                className="app-button app-button--ghost"
                onClick={() => window.history.back()}
              >
                Regresar
              </button>

              <button
                type="button"
                className="app-button app-button--ghost"
                onClick={() => window.history.forward()}
              >
                Adelante
              </button>

              {token && (
                <button
                  type="button"
                  className="app-button app-button--danger"
                  onClick={logout}
                >
                  Salir
                </button>
              )}

            </div>
          </div>
        </header>

        {/* HERO */}
        <section className="app-hero">
          <div className="app-hero-copy">
            <span className="app-eyebrow">
              {eyebrow}
            </span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>

          {heroActions && (
            <div className="app-hero-actions">
              {heroActions}
            </div>
          )}
        </section>

        {/* CONTENT */}
        <main className={`app-content ${contentClassName}`}>
          {children}
        </main>

        {/* FOOTER */}
        <Footer />

      </div>
    </div>
  );
}
